import type { OnboardingProgress } from "@/types/onboarding"

/** Ligne « Compte créé » : toujours faite, la barre ne part jamais de 0. */
export const ACCOUNT_CREATED_STEP = { mission_key: "account_created", title: "Compte créé" } as const

/** Avancement du parcours de base, « Compte créé » compris. */
export type JourneyProgress = { done: number; total: number; percentage: number }

/**
 * Avancement du parcours de base : « Compte créé » plus les missions du rôle.
 *
 * @example
 * journeyProgress({ journey: [{ completed: true }, { completed: false }] }) // { done: 2, total: 3, percentage: 67 }
 */
export function journeyProgress(progress: Pick<OnboardingProgress, "journey">): JourneyProgress {
  const total = progress.journey.length + 1
  const done = progress.journey.filter((step) => step.completed).length + 1
  return { done, total, percentage: Math.round((done / total) * 100) }
}

/** Clé du message de réussite déjà vu, par organisme. */
export function journeyDoneSeenKey(tenantKey: string): string {
  return `onboarding:base-journey-done-seen:${tenantKey}`
}

/** Drapeau posé par la page de vérification : proposer le questionnaire une fois. */
export const QUESTIONNAIRE_AFTER_VERIFY_KEY = "onboarding:questionnaire-after-verify"
